export default "__VITE_ASSET__Behpc81j__"